export const ActionTypes = {
  FETCH_PRODUCTION_OPERATIONS: 'services/productionOperation/fetch_production_operations',
  SET_PRODUCTION_OPERATIONS: 'services/productionOperation/set_production_operations',
  SET_PRODUCTION_OPERATIONS_LOADER_STATUS: 'services/productionOperation/set_production_operations_loader_status',
  ADD_UPDATE_PRODUCTION_OPERATION: 'services/productionOperation/add_update_production_operation',
  DELETE_PRODUCTION_OPERATION: 'services/productionOperation/delete_production_operation',
  ADD_JOB_PRODUCTION: 'services/productionOperation/add_job_production',
  SET_PRODUCTION_FILTER: 'services/productionOperation/set_production_filter',
  FETCH_SHIFT_PRODUCTION: 'services/productionOperation/fetch_shift_production',
  SET_SHIFT_PRDUCTION: 'services/productionOperation/set_shift_production',
  FETCH_OEE_PRODUCTION_DATES: 'services/rejectionOperation/fetch_oee_production_dates',
  SET_OEE_PRODUCTION_DATES: 'services/rejectionOperation/set_oee_production_dates',
  FETCH_PRODUCTION_HOURS: 'services/rejectionOperation/fetch_production_hours',
  SET_PRODUCTION_HOURS: 'services/rejectionOperation/set_production_hours',
  FETCH_PRODUCTION_SHIFTS: 'services/rejectionOperation/fetch_production_shifts',
  SET_PRODUCTION_SHIFTS: 'services/rejectionOperation/set_production_shifts',
};

const fetchProductionOperations = ({ productionOperationsParams }) => ({
  productionOperationsParams,
  type: ActionTypes.FETCH_PRODUCTION_OPERATIONS,
});

const setProductionOperations = ({ productionOperationsData }) => ({
  productionOperationsData,
  type: ActionTypes.SET_PRODUCTION_OPERATIONS,
});

const setProductionOperationsLoaderStatus = ({ productionOperationsLoader }) => ({
  productionOperationsLoader,
  type: ActionTypes.SET_PRODUCTION_OPERATIONS_LOADER_STATUS,
});

const addUpdateProductionOperation = ({ actionName, productionOperationObj, productionOperationsParams }) => ({
  actionName,
  productionOperationObj,
  productionOperationsParams,
  type: ActionTypes.ADD_UPDATE_PRODUCTION_OPERATION,
});

const deleteProductionOperation = ({ productionId, productionOperationsParams }) => ({
  productionId,
  productionOperationsParams,
  type: ActionTypes.DELETE_PRODUCTION_OPERATION,
});

const addJobProduction = ({ productionData, jobGridParams }) => ({
  productionData,
  jobGridParams,
  type: ActionTypes.ADD_JOB_PRODUCTION,
});

const setProductionFilter = ({ addProduction }) => ({
  addProduction,
  type: ActionTypes.SET_PRODUCTION_FILTER,
});

const fetchShiftProduction = ({ shiftProductionParams }) => ({
  shiftProductionParams,
  type: ActionTypes.FETCH_SHIFT_PRODUCTION,
});

const setShiftProduction = ({ shiftProductionData, shiftProductionParams, clear }) => ({
  shiftProductionData,
  shiftProductionParams,
  clear,
  type: ActionTypes.SET_SHIFT_PRDUCTION,
});

const fetchOeesProductionDates = ({ productionParams }) => ({
  productionParams,
  type: ActionTypes.FETCH_OEE_PRODUCTION_DATES,
});

const setOeesProductionDates = ({ productionData }) => ({
  productionData,
  type: ActionTypes.SET_OEE_PRODUCTION_DATES,
});

const fetchProductionHours = ({ productionHoursParams }) => ({
  productionHoursParams,
  type: ActionTypes.FETCH_PRODUCTION_HOURS,
});

const setProductionHours = ({ productionHoursData }) => ({
  productionHoursData,
  type: ActionTypes.SET_PRODUCTION_HOURS,
});

const fetchProductionShifts = ({ productionShiftsParams }) => ({
  productionShiftsParams,
  type: ActionTypes.FETCH_PRODUCTION_SHIFTS,
});

const setProductionShifts = ({ productionShiftsData }) => ({
  productionShiftsData,
  type: ActionTypes.SET_PRODUCTION_SHIFTS,
});

export default {
  fetchProductionOperations,
  setProductionOperations,
  setProductionOperationsLoaderStatus,
  addUpdateProductionOperation,
  deleteProductionOperation,
  addJobProduction,
  setProductionFilter,
  fetchShiftProduction,
  setShiftProduction,
  fetchOeesProductionDates,
  setOeesProductionDates,
  fetchProductionHours,
  setProductionHours,
  fetchProductionShifts,
  setProductionShifts,
};
